import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import "jspdf-autotable";
import { exportBalSheetExcel } from "./ExportBalSheetExcel";
import { exportBalSheetPDF } from "./ExportBalSheetPDF";

/*
 npm install file-saver
*/
const Profit_Loss = () => {

  const [paramFromDate, setParamFromDate] = useState();
  const [paramToDate, setParamToDate] = useState();

  const [societyName, setSocietyName] = useState();
  const [profitLossData, setProfitLossData] = useState([]);


  const handleRunReport = async () => {

    try {

      if (!paramFromDate || paramFromDate === '') {
        alert('Please enter From Date.');
        return;
      } else if (!paramToDate || paramToDate === '') {
        alert('Please enter To Date.');
        return;
      } else if (paramFromDate > paramToDate) {
        alert('From Date cannot be grater than To Date.');
        return;
      }

      const profitLossRes = await axios.get(`${BASE_URL}/api/rpt_profit_loss`,
        { params: { p_FromDate: paramFromDate, p_ToDate: paramToDate } });

      if (profitLossRes.data.length > 0) {
        setProfitLossData(profitLossRes.data);
        setSocietyName(profitLossRes.data[0].scty_name);
      } else {
        setProfitLossData([]);
        alert('No Record available');
      }

    } catch (error) {
     alert('Error in Profit/Loss Statement : ', error);
   }
 
  };

  function formatCurrency(amount) {

    if (amount) {
      const numberFormat = new Intl.NumberFormat('en-IN', {
        style: 'decimal', //'currency',
        minimumFractionDigits: 2,
        currency: 'INR',
        currencyDisplay: 'symbol',
      });
      return numberFormat.format(amount);
    } else {
      return amount;
    }

  }

  /// Export to Excel
  const handleDownloadExcel = () => {

    exportBalSheetExcel({
      profitLossData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName,
    });

  };

  /// download PDF
  const handleDownloadPDF = () => {

    exportBalSheetPDF({
      profitLossData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName,
    });

  };

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="mb-3 p-2">

        <Row className="mt-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>From Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramFromDate}
              onChange={(e) => setParamFromDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>To Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          <Col md={6} className="d-flex justify-content-end">
            <Button style={{height: '40px'}} className="me-2" variant="success" onClick={handleRunReport} >Run Report</Button>
            <Button style={{height: '40px'}} className="me-2" variant="warning" onClick={handleDownloadPDF} disabled={profitLossData.length === 0}>PDF File</Button>
            <Button style={{height: '40px'}} className="me-2" variant="secondary" onClick={handleDownloadExcel} disabled={profitLossData.length === 0}>Excel file</Button>
          </Col>

        </Row>

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '380px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }}  className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'left', width: '45%' }}>Particulars</th>
                <th style={{ textAlign: 'right', width: '20%' }} className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
            {profitLossData.length > 0 ? (
                profitLossData.map((pl, idx) => (
                  <tr style={{ 
                    fontWeight: pl.inc_exp === 1 || pl.inc_exp === 11 || pl.inc_exp === 21 || pl.inc_exp === 8 || pl.inc_exp === 18 ? 'bold' : 'normal',
                    backgroundColor: pl.particulars === 'TOTAL INCOME' || pl.particulars === 'TOTAL EXPENSES' ? '#f0f0f0' : 
                    (pl.inc_exp === 1 || pl.inc_exp === 11) ? 'lightblue' :
                    'transparent'
                  }} >
                    <td style={{ textAlign: 'left' }}>
                      <span style={{ color: (pl.inc_exp === 1 || pl.inc_exp === 11) ? 'blue' : 
                                      (pl.inc_exp === 21 && pl.particulars === 'NET PROFIT') ? 'green' :
                                      (pl.inc_exp === 21 && pl.particulars === 'NET LOSS') ? 'red' :
                                       'black' }}>
                        {pl.particulars}
                      </span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <span style={{
                        color: (pl.inc_exp === 21 && pl.particulars === 'NET PROFIT') ? 'green' :
                          (pl.inc_exp === 21 && pl.particulars === 'NET LOSS') ? 'red' :
                            'black'
                      }}>
                        {formatCurrency(pl.amount)}
                      </span>
                      </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center">
                    No Record found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </Card>
    </Container>
  );
};

export default Profit_Loss;
